import React, { useMemo } from "react";
import { Doughnut } from "react-chartjs-2";
import { Box, useTheme } from "@mui/material";
import {
  ArcElement,
  ChartData,
  Chart as ChartJS,
  ChartOptions,
  Legend,
  Tooltip,
} from "chart.js";
import "chart.js/auto";
import { OcChartData } from "oc/components/chart";

ChartJS.register(ArcElement, Tooltip, Legend);

interface OcDoughnutProps {
  cutout: ChartOptions<"doughnut">["cutout"];
  size: string;
  data: OcChartData[] | null;
  dataBorder?: boolean;
  loading?: boolean;
  tooltipEnabled?: boolean;
}

export const OcDoughnut: React.FC<OcDoughnutProps> = ({
  cutout,
  size,
  data,
  dataBorder,
  loading,
  tooltipEnabled = true,
}) => {
  const theme = useTheme();

  const options: ChartOptions<"doughnut"> = {
    cutout: cutout,
    maintainAspectRatio: true,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: tooltipEnabled && !loading },
    },
    animation: {
      duration: loading ? 0 : 1000,
    },
  };

  const shownData = useMemo(() => {
    const loadingData: ChartData<"doughnut", number[], string> = {
      datasets: [
        {
          data: [1],
          backgroundColor: [theme.palette.gray40.main],
          hoverBackgroundColor: [theme.palette.gray40.main],
          borderColor: dataBorder ? [theme.palette.gray40.main] : ["white"],
        },
      ],
      labels: ["1"],
    };

    let returnData: ChartData<"doughnut", number[], string> = loadingData;

    if (!loading && data) {
      returnData = {
        datasets: [
          {
            data: data.map((item) => item.value),
            backgroundColor: data.map((item) => item.color),
            hoverBackgroundColor: data.map((item) => item.color),
            borderWidth: dataBorder ? 0 : undefined,
          },
        ],
        labels: data.map((item) => item.label),
      };
    }

    return returnData;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, data, dataBorder]);

  return (
    <Box height={size} width={size}>
      <Doughnut
        data={shownData}
        options={options}
        style={{
          position: "absolute",
          zIndex: 2,
        }}
      />
    </Box>
  );
};
